import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="py-20 md:py-28 bg-white relative overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at top, rgba(59,130,246,0.08), transparent 55%)',
        }}
      />

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 mb-4">
            Ready to Streamline Your Freight?
          </h2>
          <p className="text-zinc-500 text-lg mb-10 max-w-xl mx-auto">
            Join hundreds of carriers and shippers who use LoadAPI.io to move more loads with less effort.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/join"
              className="px-8 py-3.5 bg-blue-600 text-white text-sm font-semibold rounded-full hover:bg-blue-700 transition-colors whitespace-nowrap"
            >
              Start Free Trial
            </Link>
            <Link
              to="/join"
              className="px-8 py-3.5 bg-zinc-100 text-zinc-900 text-sm font-semibold rounded-full hover:bg-zinc-200 transition-colors whitespace-nowrap"
            >
              View Pricing
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}